import { useEffect, useMemo } from 'react'

import { v4 as uuidv4 } from 'uuid'

/**
 * Session ID vs Browser ID:
 * - Session ID (sessionStorage): Temporary ID that persists only for the current browser tab and is cleared when the tab closes
 * - Browser ID (localStorage): Persistent ID that survives across browser sessions, tab closures, and computer restarts
 */
export const usePersistentIds = () => {
  const sessionId = useMemo(() => {
    return sessionStorage.getItem('sessionId') || uuidv4()
  }, [])

  const browserId = useMemo(() => {
    return localStorage.getItem('browserId') || uuidv4()
  }, [])

  useEffect(() => {
    sessionStorage.setItem('sessionId', sessionId)
  }, [sessionId])

  useEffect(() => {
    localStorage.setItem('browserId', browserId)
  }, [browserId])

  return {
    sessionId,
    browserId,
  }
}
